export default "__VITE_ASSET__CsV8CLSF__"